import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/auth-store'
import { awaitAuthReady } from '@/lib/auth-guards'
import { AuthenticatedLayout } from '@/components/layout/authenticated-layout'

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ location }) => {
    await awaitAuthReady()
    const { status, getRole } = useAuthStore.getState()
    if (status === 'unauthenticated') {
      let searchString = ''
      if (typeof location.search === 'string') {
        searchString = location.search
      } else if (location.search) {
        searchString = `?${new URLSearchParams(location.search).toString()}`
      }

      const redirectUrl = `${location.pathname}${searchString}${location.hash ?? ''}`
      throw redirect({
        to: '/sign-in',
        search: { redirect: redirectUrl },
      })
    }

    const role = getRole()

    if (
      role === 'system' &&
      !location.pathname.startsWith('/system/check-ins')
    ) {
      throw redirect({ to: '/system/check-ins' })
    }
  },
  component: AuthenticatedLayout,
})
